import { render, staticRenderFns } from "./RenoReviewRating.vue?vue&type=template&id=31c8ee2e&scoped=true&"
import script from "./RenoReviewRating.vue?vue&type=script&lang=ts&"
export * from "./RenoReviewRating.vue?vue&type=script&lang=ts&"
import style0 from "./RenoReviewRating.vue?vue&type=style&index=0&id=31c8ee2e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31c8ee2e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
